<!-- <div class="dialog-container-W750-H600" [ngClass]="inlineComponent ? 'custom-inline-component' : ''">
  <div class="flex justify-between" style="border-bottom: 1px solid #53565b22; margin: 0 -24px; padding: 0px 24px 12px 24px">
    <p class="text-2xl font-bold" style="margin: 0px; position: relative; text-align: start; width: -webkit-fill-available">Manage Reminders</p>
    <div class="flex flex-row">
      <form [formGroup]="reminderForm">
        <mat-select
          panelClass="move-select-popup"
          name="frequency"
          style="line-height: 28px !important; margin-right: 6px"
          formControlName="status"
          [disableOptionCentering]="true"
          [ngClass]="[
            reminderForm.controls.status.value === 'notstarted'
              ? 'small-inprogress inprogress'
              : '' || reminderForm.controls.status.value === 'inprogress'
              ? 'small-notstarted notstarted'
              : '' || reminderForm.controls.status.value === 'complete'
              ? 'small-complete complete'
              : ''
          ]"
          [style]="{
            width: '148px',
            height: '28px !important',
            padding: '0px 13px',
            borderRadius: '6px'
          }"
        >
          @for (stat of status; track stat) {
          <mat-option [ngClass]="stat.className" [value]="stat.value">
            <div [style]="{ height: '37px', width: 'fit-content' }">
              <span>
                {{ stat.displayText }}
              </span>
            </div>
          </mat-option>
          }
        </mat-select>
      </form>

      <button type="button" class="close add-close-button" data-dismiss="modal" (click)="closeDialogReminder()">
        <span style="font-size: 24px; font-weight: 600; color: #707070" class="material-icons icons-close-mobile">close</span>
      </button>
    </div>
  </div>

  @if(is_loading){
  <div class="mt-6" style="height: 320px">
    <div class="loader-container flex flex-col w-full">
      @for (item of [1,2,3]; track item) {
      <div style="width: 100%">
        <div class="flex loader-body" style="width: 100%">
          <div class="ph-item width-100per loader-body-item" style="padding: 18px 12px 9px 12px">
            <div class="ph-col-12" style="padding: 0px !important">
              <div class="ph-row">
                <div class="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  }@else{
  <div>
    <form [formGroup]="reminderForm" style="overflow: auto; max-height: 458px; margin-bottom: 12px; padding-right: 12px">
      <p class="font-semibold text-xs mt-3 text-[#487AF0]">Reminder Title</p>
      <mat-form-field [floatLabel]="'auto'" appearance="fill" style="width: 100% !important" class="form__mat-text-field app__medium--height--form">
        <input matInput formControlName="title" placeholder="Untitled Reminder" type="text" />
      </mat-form-field>

      <p class="font-semibold text-xs text-[#487AF0]">Owner</p>
      <div class="flex flex-row justify-between mb-3 cursor-pointer px-4 py-2.5 border rounded border-[#e5e7eb]" (click)="openAddOwnerUser()">
        <div class="flex flex-row">
          <ngx-avatars
            size="24"
            [src]="ownerUserProfile.image"
            [name]="ownerUserProfile.name"
            [round]="false"
            initialsSize="2"
            cornerRadius="100"
          ></ngx-avatars>
          <p class="font-semibold text-xs" style="margin: 4px 0px 0px 8px">{{ ownerUserProfile.name | truncateStrPipe : 20 }}</p>
        </div>
      </div>

      <p class="font-semibold text-xs text-[#487AF0]">Reminder Details</p>
      <mat-form-field [floatLabel]="'auto'" appearance="fill" style="width: 100% !important" class="form__mat-text-field app__medium--height--form">
        <mat-label class="automtic-form-desing-lable">Action</mat-label>
        <mat-select
          panelClass="move-select-popup"
          [disabled]="disabled_fields.action"
          matNativeControl
          disableOptionCentering
          formControlName="action"
        >
          @for (item of action_list; track item) {
          <mat-option [value]="item?.value">
            {{ item.label }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if(reminderForm.controls.action.value == 'other') {
      <mat-form-field [floatLabel]="'auto'" appearance="fill" style="width: 100% !important" class="form__mat-text-field app__medium--height--form">
        <input matInput formControlName="action_other" placeholder="Action Other" type="text" />
      </mat-form-field>
      }

      <mat-form-field [floatLabel]="'auto'" appearance="fill" style="width: 100% !important" class="form__mat-text-field app__medium--height--form">
        <mat-label class="automtic-form-desing-lable">Object</mat-label>
        <mat-select panelClass="move-select-popup" matNativeControl disableOptionCentering formControlName="object_description">
          @for (item of reminder_object_list; track item) {
          <mat-option [value]="item.value">
            {{ item.label }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if(reminderForm.controls.object_description.value == 'Other') {
      <mat-form-field [floatLabel]="'auto'" appearance="fill" style="width: 100% !important" class="form__mat-text-field app__medium--height--form">
        <input matInput formControlName="object_description_other" placeholder="What is the other object?" type="text" />
      </mat-form-field>
      }

      <p class="font-semibold text-xs text-[#487AF0]">Timeline</p>
      <div class="bg-[#f4f6fc] pr-5 pl-5 pt-5 rounded">
        <div class="flex">
          <button
            class="h-11 rounded mr-1.5"
            (click)="setReminderType('asap')"
            [ngClass]="reminderForm.controls.reminder_type.value == 'asap' ? 'time_line_active_btn' : 'time_line_deactive_btn'"
          >
            ASAP
          </button>
          <button
            class="h-11 rounded mr-1.5"
            [ngClass]="reminderForm.controls.reminder_type.value == 'future' ? 'time_line_active_btn' : 'time_line_deactive_btn'"
            (click)="setReminderType('future')"
          >
            On a Future Date
          </button>
          <button
            class="h-11 rounded mr-1.5"
            [ngClass]="reminderForm.controls.reminder_type.value == 'depend' ? 'time_line_active_btn' : 'time_line_deactive_btn'"
            (click)="setReminderType('depend')"
          >
            Based on a Trigger
          </button>
        </div>

        @if(reminderForm.controls.reminder_type.value == 'asap') {
        <mat-form-field
          [floatLabel]="'auto'"
          appearance="fill"
          style="width: 100% !important"
          class="form__mat-text-field app__medium--height--form mt-3 disabled-mat-field"
        >
          <mat-label class="automtic-form-desing-lable">Start Date</mat-label>
          <input matInput disabled formControlName="start_date" type="text" />
        </mat-form-field>
        <mat-form-field
          [floatLabel]="'auto'"
          appearance="fill"
          style="width: 100% !important"
          class="form__mat-text-field app__medium--height--form disabled-mat-field"
        >
          <mat-label class="automtic-form-desing-lable">Finish Date</mat-label>
          <input matInput disabled formControlName="finish_date" type="text" />
        </mat-form-field>
        } @if(reminderForm.controls.reminder_type.value == 'future' || reminderForm.controls.reminder_type.value == 'depend') {
        @if(reminderForm.controls.reminder_type.value == 'depend'){
        <mat-form-field
          [floatLabel]="'auto'"
          appearance="fill"
          style="width: 100% !important"
          class="form__mat-text-field app__medium--height--form mt-3"
        >
          <mat-label class="automtic-form-desing-lable">Select Trigger Date</mat-label>
          <mat-select panelClass="move-select-popup" matNativeControl disableOptionCentering formControlName="trigger_date">
            @if(this.reminderForm.controls.trigger_date.value == 'Last Updated'){
            <mat-option value="Last Updated"> Last Updated </mat-option>
            }@else{ @for (item of triggerTypeOptions; track item) {
            <mat-option [value]="item?.value" [disabled]="item.is_disable">
              {{ item.label }}
            </mat-option>
            } }
          </mat-select>
        </mat-form-field>
        }
        <mat-form-field
          [floatLabel]="'auto'"
          appearance="fill"
          style="width: 100% !important"
          class="form__mat-text-field app__medium--height--form mt-3"
        >
          <mat-label class="automtic-form-desing-lable">Trigger Date is</mat-label>
          <mat-select panelClass="move-select-popup" matNativeControl disableOptionCentering formControlName="timeline_future_date_is">
            @for (item of timeline_type_list; track item) {
            <mat-option [value]="item?.value">
              {{ item.label }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field
          [floatLabel]="'auto'"
          appearance="fill"
          style="width: 100% !important"
          [ngClass]="{ 'disabled-mat-field': reminderForm.controls.timeline_future_date_is.value == 'Finish by Date' }"
          class="form__mat-text-field app__medium--height--form"
        >
          <mat-label class="automtic-form-desing-lable">
            <span class="truncate-label">Start Date</span>
          </mat-label>
          <input
            matInput
            [matDatepicker]="dp3"
            (click)="dp3.open()"
            [disabled]="reminderForm.controls.timeline_future_date_is.value == 'Finish by Date'"
            (dateChange)="addEvent('change', $event)"
            formControlName="timeline_start_date"
          />
          <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
          <mat-datepicker #dp3 [disabled]="reminderForm.controls.timeline_future_date_is.value == 'Finish by Date'"></mat-datepicker>
        </mat-form-field>

        <p class="font-semibold text-xs text-[#487AF0]">Time to Complete</p>
        <div class="flex flex-row">
          <mat-form-field
            [floatLabel]="'auto'"
            appearance="fill"
            style="width: 100% !important"
            class="form__mat-text-field app__medium--height--form mr-1.5"
          >
            <mat-select panelClass="move-select-popup" matNativeControl disableOptionCentering formControlName="timeline_period">
              <mat-option value=""> Select </mat-option>
              @for (item of timeline_period_list; track item) {
              <mat-option [value]="item?.value">
                {{ item.label }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field
            [floatLabel]="'auto'"
            appearance="fill"
            style="width: 100% !important"
            class="form__mat-text-field app__medium--height--form ml-1.5"
          >
            <mat-select panelClass="move-select-popup" matNativeControl disableOptionCentering formControlName="timeline_period_type">
              <mat-option value=""> Select </mat-option>
              @for (item of timeline_period_type_list; track item) {
              <mat-option [value]="item?.value">
                {{ item.label }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field
          [floatLabel]="'auto'"
          appearance="fill"
          [ngClass]="{ 'disabled-mat-field': reminderForm.controls.timeline_future_date_is.value == 'Start by Date' }"
          style="width: 100% !important"
          class="form__mat-text-field app__medium--height--form"
        >
          <mat-label class="automtic-form-desing-lable">
            <span class="truncate-label">Finish Date</span>
          </mat-label>
          <input
            matInput
            [matDatepicker]="dp4"
            (click)="dp4.open()"
            (dateChange)="addEvent('change', $event)"
            [disabled]="reminderForm.controls.timeline_future_date_is.value == 'Start by Date'"
            formControlName="timeline_finish_date"
          />
          <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
          <mat-datepicker #dp4 [disabled]="reminderForm.controls.timeline_future_date_is.value == 'Start by Date'"></mat-datepicker>
        </mat-form-field>
        @if(reminderForm.controls.reminder_type.value == 'depend' && reminderForm.controls.timeline_future_date_is.value == 'Start by Date' ){
        <mat-slide-toggle
          style="color: #25508e; font-family: Open Sans; font-style: normal; font-weight: 600; font-size: 14px; margin-bottom: 22.4px !important"
          class="array-item-title section-lable margin-zero mb-0 mt-0"
          formControlName="delay_from_start_date"
        >
          Delay from Start Date
        </mat-slide-toggle>
        @if(reminderForm.controls.delay_from_start_date.value){
        <div class="flex flex-row">
          <mat-form-field
            [floatLabel]="'auto'"
            appearance="fill"
            style="width: 100% !important"
            class="form__mat-text-field app__medium--height--form mr-1.5"
          >
            <mat-select panelClass="move-select-popup" matNativeControl disableOptionCentering formControlName="delay_from_start_date_period">
              <mat-option value=""> Select </mat-option>
              @for (item of timeline_period_list; track item) {
              <mat-option [value]="item?.value">
                {{ item.label }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field
            [floatLabel]="'auto'"
            appearance="fill"
            style="width: 100% !important"
            class="form__mat-text-field app__medium--height--form ml-1.5"
          >
            <mat-select panelClass="move-select-popup" matNativeControl disableOptionCentering formControlName="delay_from_start_date_period_type">
              <mat-option value=""> Select </mat-option>
              @for (item of timeline_period_type_list; track item) {
              <mat-option [value]="item?.value">
                {{ item.label }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        } } }
      </div>
    </form>
    <button
      mat-raised-button
      type="submit"
      [ngClass]="!is_form_valid ? 'app__btn--disabled mt-0' : 'app__btn--primary mt-0 cursor-pointer'"
      (click)="addAttribute()"
    >
      Save
    </button>
  </div>
  }
</div> -->

<div class="dialog-container-W750-H600">
  <div class="flex justify-between" style="margin: 0 -24px; padding: 0px 24px 12px 24px">
    <div style="width: 100%">
      <div class="py-24">
        <div class="flex items-center flex-col justify-center gap-2">
          <p class="font-bold text-2xl">One moment while we create <span class="text-k-blue"> reminder</span></p>
          <ng-lottie [options]="animation" width="235px" height="235px" class="w-[235px] h-[235px]"></ng-lottie>

          <p class="m-0 text-[18px] font-semibold text-[#707070]">This process should only take a few seconds...</p>
        </div>
      </div>
    </div>
  </div>
</div>
